import { call, put, select, takeLatest, fork } from 'redux-saga/effects'

import RootState from '../root-state'
import { auth0Actions } from '../auth0'
import { toastActions } from '../toast'
import { getFoodPriceHistories } from '../api'
import { foodPriceHistoryActions, foodPriceHistoryActionType } from './actions'
import { FoodPriceHistoryParam } from './food-price-histories'

function* fetchFoodPriceHistories(
  action: ReturnType<typeof foodPriceHistoryActions.fetchFoodPriceHistories>
) {
  try {
    yield put(auth0Actions.checkSession())
    const state: RootState = yield select()
    const token = state.auth0.auth.idToken

    const params: FoodPriceHistoryParam = action.payload
    const response = yield call(getFoodPriceHistories, token, params)
    const pagination = {
      page: params.page,
      per: params.per,
      total: response.totalCount,
    }
    yield put(
      foodPriceHistoryActions.fetchFoodPriceHistoriesSucceeded(
        response.priceHistories,
        pagination
      )
    )
  } catch (error) {
    yield put(foodPriceHistoryActions.throwError(error))
    yield put(
      toastActions.show({
        type: 'error',
        title: '取得に失敗しました',
        body: 'フード価格変更履歴を取得できませんでした',
      })
    )
  }
}

export function* watchFetchFoodPriceHistories() {
  yield takeLatest(
    foodPriceHistoryActionType.FETCH_FOOD_PRICE_HISTORIES,
    fetchFoodPriceHistories
  )
}

export const foodPriceHistorySagas = [fork(watchFetchFoodPriceHistories)]
